import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// import clsx from 'clsx';
import _ from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import DialogTitle from '@material-ui/core/DialogTitle'; // substituted by custom
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';

import DialogTitle from 'components/DialogTitle';
import { editClaim } from '../store/claims.slice';
import { openDialog, closeDialog } from '../store/discuss.slice';

const useStyles = makeStyles(theme => ({
  root: {
    // border: 'solid black 1px', // DEBUG
  },
  closeButton: {
    claim: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function ClaimEdit(props) {
  const {
    show,
    claim,
    // pending, // @todo
    // error,
    openDialog,
    onOpen,
    onClose,
    onEdit,
  } = props;
  const classes = useStyles();
  const [values, setValues] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  const handleSave = (event) => {
    event.preventDefault();
    onEdit(values);
  };

  const buildTrigger = () => (
    <IconButton
      size="small"
      color="inherit"
      aria-label="Edit claim"
      onClick={onOpen}
    >
      <EditIcon />
    </IconButton>
  );

  const buildForm = () => (
    <TextField
      name="text"
      autoComplete="text" // @todo REMOVE it. Only for an easy develop
      label="Edit your claim"
      variant="filled"
      defaultValue={_.get(claim, 'text', '')}
      rows={3}
      required
      multiline
      fullWidth
      onChange={handleChange}
    />
  );

  const buildActions = () => (<>
    <Button
      variant="contained"
      size="small"
      onClick={onClose}
    >Cancel</Button>
    <Button
      variant="contained"
      color="secondary"
      size="small"
      // className={classes.button}
      startIcon={<SaveIcon />}
      onClick={handleSave}
    >Save</Button>
  </>);

  useEffect(() => {
    if (claim) {
      setValues(claim);
    }
  }, [claim]);

  // console.log('ClaimDimensionsCast', props); // DEBUG

  return (
    <div className={classes.root}>
      {show && buildTrigger()}
      <Dialog
        open={openDialog}
        // maxWidth="md"
        fullWidth={true}
        onClose={onClose}
      >
        <DialogTitle onClose={onClose}>Edit argument</DialogTitle>
        <DialogContent>
          {buildForm()}
        </DialogContent>
        <DialogActions>
          {buildActions()}
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const claim = ownProps.claim;
  const dialogState = state.discuss.layout.dialogs;
  // const authUser = state.auth.profile;
  const uid = _.get(state.auth.profile, 'uid', false);

  // @todo move in a selectort ?
  const claimsState = state.discuss.claims;
  const agreementsState = state.discuss.claimAgreements;
  const thumbsState = state.discuss.claimThumbs;
  const heartsState = state.discuss.claimHearts;
  const dimensionsState = state.discuss.claimDimensions;

  return {
    openDialog: dialogState.claimEdit === claim.id,
    show: uid === claim.metadata.createdBy
      && !_.some(claimsState.byId, ['parentId', claim.id])
      && !_.has(agreementsState, `byId[${claim.id}]`)
      && !_.has(thumbsState, `byId[${claim.id}]`)
      && !_.has(heartsState, `byId[${claim.id}]`)
      && !_.has(dimensionsState, `byId[${claim.id}]`)
      ,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const claim = ownProps.claim;
  return {
    onEdit: values => {
      return dispatch(editClaim(values))
        .then(res => {
          if (res.meta.requestStatus === 'fulfilled') {
            dispatch(closeDialog('claimEdit'));
          }
          return res;
        });
    },
    onOpen: () => dispatch(openDialog({
      resourceName: 'claimEdit',
      resourceId: claim.id,
    })),
    onClose: () => dispatch(closeDialog('claimEdit')),
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClaimEdit);
